import Person from "./Person";
import INetWorth from "./INetWorth";
import Model from "./Model";
import {isoToLocalDate} from "../stores/StoreUtilities";
import IModelItem from "./IModelItem";

interface ILiability {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  description: string
  balance: number
  balanceDate: string
  start: string
  end: string
  payoffDate: string
  interestRate: number
  ownerId: string
  sortOrder: number
  archived: boolean
}

class Liability implements IModelItem, INetWorth {
  id: string
  createdAt: string
  updatedAt: string
  accountId: string
  userId: string
  modelId: string
  model?: Model
  description: string
  balance: number
  balanceDate: Date
  start: string
  end: string
  payoffDate: string
  interestRate: number
  ownerId: string
  owner?: Person
  sortOrder: number
  archived: boolean

  constructor(data: any) {
    this.id = data.id
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.accountId = data.accountId
    this.userId = data.userId
    this.modelId = data.modelId
    this.model = data.model
    this.description = data.description ?? "Other"
    this.balance = data.balance ?? 0
    this.balanceDate = data.balanceDate ? isoToLocalDate(data.balanceDate) : isoToLocalDate(data.updatedAt)
    this.start = data.start
    this.end = data.end
    this.payoffDate = data.payoffDate
    this.interestRate = data.interestRate
    this.ownerId = data.ownerId
    this.sortOrder = data.sortOrder
    this.archived = data.archived === true
  }

  getTypename(): string {
    return "Liability"
  }

  get startDate(): Date | undefined {
    return this.model?.getDate(this.start)
  }

  get endDate(): Date | undefined {
    return this.model?.getDate(this.end)
  }

  get endYear(): number {
    const date = this.endDate
    if (date) {
      return date.getFullYear()
    } else {
      return 0
    }
  }

  toJSON(): ILiability {
    return {
      id: this.id,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt,
      accountId: this.accountId,
      userId: this.userId,
      modelId: this.modelId,
      description: this.description,
      balance: this.balance,
      balanceDate: this.balanceDate ? this.balanceDate.toISOString() : "",
      start: this.start,
      end: this.end,
      payoffDate: this.payoffDate,
      interestRate: this.interestRate,
      ownerId: this.ownerId,
      sortOrder: this.sortOrder,
      archived: this.archived
    }
  }

}

export default Liability